<template>
  <panel title="Edycja dokumentu">
    <w-wysiwyg class="mb-2" title="Dokument" :model="$schema.html" :config="config" />

    <div slot="footer">
      <post-form
        class="mr-2"
        icon="fal fa-cloud-download mr-2"
        button-class="btn-info"
        text="Pobierz pdf"
        :fields="viewFormFields"
        :url="pdfUrl"
      />

      <w-button class="btn-primary float-right" text="Zapisz dokument" @click="saveAsAttachment" />

      <w-button
        v-if="documentIndex.systemNumbers && documentIndex.systemNumbers.mdokId"
        class="btn-danger float-right mr-2"
        text="Prześlij do MDOK"
        @click="saveToMDOK"
      />

      <w-button class="btn-warning float-right mr-2" text="Anuluj edycję" @click="goToGenerate" />
    </div>
  </panel>
</template>

<script>
import { mapState } from 'vuex';

import Panel from '@/components/panel/Panel';
import PostForm from '@/components/postForm/PostForm';
import { Errors } from '@/enums/errors.enum';
import { Storage } from '@/enums/storage.enum';
import { Successes } from '@/enums/successes.enum';
import { formMixin } from '@/mixins/form';
import { notificationsMixin } from '@/mixins/notifications';
import { renderMixin } from '@/mixins/render';
import schema from '@/schemas/generate.schema';
import { tryParseInt } from '@/utils/number';

// @vuese
// Edycja HTML'a widoku
// @group Document
export default {
  components: { Panel, PostForm },
  mixins: [formMixin, renderMixin, notificationsMixin],
  props: {
    // Pozostałe dane
    data: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  schema,
  data() {
    return {
      model: {},
      config: { allowedContent: true, height: 450 }
    };
  },

  computed: {
    ...mapState({
      documentIndex: state => state.documentIndex.data,
      previewHTML: state => state.view.previewHtml,
      attachmentIds: state => state.view.previewData.attachmentIds
    }),
    documentId() {
      return this.$route.params.documentId;
    },
    viewId() {
      return this.$route.params.viewId;
    },
    viewFormFields() {
      const data = this.$schema.$getData();
      return Object.keys(data).map(key => ({ name: key, value: data[key] }));
    },
    pdfUrl() {
      return this.getPdfFromHtmlUrl(this.viewId);
    },
    previewUrl() {
      return this.getPreviewURL(this.documentId, this.viewId);
    }
  },
  mounted() {
    if (this.previewHTML) {
      this.$schema.html.$setData(this.previewHTML);
    }
  },
  destroyed() {
    localStorage.removeItem(Storage.HTML_EDIT);
  },
  methods: {
    // @vuese
    // Zapisywanie wyedytowanego HTMLa do MDOK
    saveToMDOK() {
      this.save('view/saveEditedHtmlToMDOK');
    },

    // @vuese
    // Zapisywanie wyedytowanego HTMLa do załącznika
    saveAsAttachment() {
      this.save('view/saveEditedHtmlAsAttachment');
    },

    // @vuese
    // Zapisywanie wyedytowanego HTMLa
    save(action) {
      this.$store
        .dispatch(action, {
          viewId: tryParseInt(this.viewId),
          data: { ...this.data, attachmentIds: this.attachmentIds },
          documentId: tryParseInt(this.documentId),
          html: this.$schema.$getData().html
        })
        .then(() => {
          this.notifySuccess(Successes.ATTACHMENT_SAVED);
          this.goToGenerate();
        })
        .catch(err => this.notifyError(Errors.ERROR_TRY_AGAIN_LATER));
    },
    // @vuese
    // Powrót do `documentGenerate`
    goToGenerate() {
      this.$router.push({ name: 'documentGenerate' });
    }
  }
};
</script>
